import ko from 'knockout';
import $ from 'jquery';
import _ from 'lodash';
import FormatterCommon from './formatter-common';
import GridFormatterCommon from './grid-formatter-common';
import FilterFormatter from './filter-formatter';
import EndpointsCommon from '../helpers/endpoints-common';

    

    function EndpointMgmtGridFormatter(params, observableOptions) {

        var self = this;

        self.observableOptions = observableOptions;

        self.formatterCommon = FormatterCommon;
        self.gridFormatterCommon = new GridFormatterCommon();
        self.filterFormatter = new FilterFormatter();

        self.isCallControl = params && params.type === "CallControl";
        self.isBridge = params && params.type === "Bridge";

        self.observableFormattedData = ko.observable({});

        self.subscriptions = [];
    }

    function ComposeData(formatters, sourceList, endpointCallData, options, self, optionsUpdated, metadata) {
        var headers = metadata.searchgrid.headers;
        var rowProperties = metadata.searchgrid.rowProperties;
        const widths = ['', '', '', '', '', '', '', '', '', '', '', '', ''];
        
        if ($.isEmptyObject(sourceList)) {
            return formatters.gridFormatterCommon.composeEmpty(headers, rowProperties, widths);
        }
        var list = [];
        var finalList = [];
        var searchfilter = formatters.filterFormatter.toTypeaheadFilter(_.get(options, 'filter'));

        sourceList.forEach(function (item) {
            // We create this new property because the Endpoint Tag filter defined data-repository looks for this property
            // TODO: Refactor so filters can refer to a list of properties instead of creating properties that aggregate others.
            if (item.tags && item.tmsTag) {
                item._allTags = item.tags + ',' + item.tmsTag;
            }
            else {
                item._allTags = item.tags || item.tmsTag || '';
            }

            if (_.isEmpty(searchfilter) || formatters.filterFormatter.matchAll(item, searchfilter)) {
                list.push({
                    id: item.id,
                    name: item.name,
                    aliases: item.aliases,
                    dn: item.dn || "",
                    model: item.model || "",
                    firmware: item.firmware,
                    host: item.host,
                    altName: item.altName || '',
                    description: item.description || '',
                    price: item.price || '',
                    location: item.location || '',
                    tags: item.tags || '',
                    tmsTags: item.tmsTag || '',
                    solarwindsLink: item.solarwindsLink,
                });
            }
        });
        var sortedList = formatters.gridFormatterCommon.sortList(list, metadata.searchgrid.searchableProperties, options);
        var pagedList = formatters.gridFormatterCommon.pageList(sortedList, options);

        pagedList.forEach(function (item) {
            finalList.push({
                id: item.id,
                name: formatters.gridFormatterCommon.getSolarWindsAndDetailLink(formatters.formatterCommon.sanitize(item.name), item.solarwindsLink, item.id),
                aliases: formatters.formatterCommon.sanitize(item.aliases),
                dn: formatters.formatterCommon.sanitize(item.dn) || "",
                model: formatters.formatterCommon.getSpanTitle(item.model),
                firmware: formatters.formatterCommon.getSpanTitle(item.firmware),
                host: formatters.gridFormatterCommon.getLinkWithHost(formatters.formatterCommon.sanitize(item.host)),
                altName: formatters.formatterCommon.sanitize(item.altName),
                description: formatters.formatterCommon.sanitize(item.description),
                price: formatters.formatterCommon.sanitize(item.price),
                location: formatters.formatterCommon.sanitize(item.location),
                customTags: formatters.formatterCommon.sanitize(item.tags),
                customTagsFormatted: formatters.formatterCommon.sanitize(EndpointsCommon.tagsRawToDisplay(item.tags)),
                tmsTags: formatters.formatterCommon.sanitize(item.tmsTags),
                tmsTagsFormatted: formatters.formatterCommon.sanitize(EndpointsCommon.tagsRawToDisplay(item.tmsTags)),
                edit: '<i class="fa fa-edit edit-icon" title="Edit"></i>'
            });
        });

        self.allAcrossSelectedObs = ko.observable(false);

        return {
            maxCount: list.length,
            rows: finalList,
            rowProperties: rowProperties,
            origlist: sortedList,
            headers: headers,
            widths: widths, //12 cols
            innerRowDisplayIndex: 0,
            optionsUpdated: optionsUpdated
        };
    }

    EndpointMgmtGridFormatter.prototype.RefreshData = function (optionsUpdated) {
        var self = this;
        self.observableFormattedData(
            ComposeData(
                {
                    formatterCommon: self.formatterCommon,
                    gridFormatterCommon: self.gridFormatterCommon,
                    filterFormatter: self.filterFormatter
                },
                self.dataRepository.endpointStatusData(),
                self.dataRepository.endpointCallData(),
                self.observableOptions(),
                self,
                optionsUpdated,
                self.dataRepository.getEndpointManagementMetadata()
            )
        );
    };

    EndpointMgmtGridFormatter.prototype.DataUpdated = function () {
        var self = this;
        self.RefreshData(false);
    };

    EndpointMgmtGridFormatter.prototype.OptionsUpdated = function () {
        var self = this;
        self.RefreshData(true);
    };

    EndpointMgmtGridFormatter.prototype.initialize = function (dataRepository) {
        var self = this;

        self.dataRepository = dataRepository;

        self.subscriptions.push(dataRepository.endpointStatusData.subscribe(function () { self.DataUpdated(); }));
        self.subscriptions.push(self.observableOptions.subscribe(function () { self.OptionsUpdated(); }));

        //initialize data if it is there, so that if it isn't a 'loading' icon will show on UI
        if (!_.isEmpty(dataRepository.endpointStatusData()) || _.isEmpty(self.observableFormattedData())) {
            self.RefreshData();
        }
    };

    EndpointMgmtGridFormatter.prototype.getObservableData = function () {
        var self = this;
        return self.observableFormattedData;
    };

    EndpointMgmtGridFormatter.prototype.dispose = function() {
        var self = this;
        self.subscriptions.forEach(function (sub) {
            sub.dispose();
        });
    };

    export default EndpointMgmtGridFormatter;
